/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown>, count: NonNullable<unknown> }} Assistant_Activity_Created_GroupInputs */



/**
* | output |
* | --- |
* | "Created the group {group} with {count} events" |
*
* @param {Assistant_Activity_Created_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_created_group = /** @type {((inputs: Assistant_Activity_Created_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_Created_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Création du groupe ${i?.group} avec les événements ${i?.count}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Gruppe ${i?.group} mit den Ereignissen ${i?.count} wurde erstellt.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Creato il gruppo ${i?.group} con eventi ${i?.count}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Создана группа ${i?.group} с событиями ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se creó el grupo ${i?.group} con los eventos ${i?.count}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`创建了包含 ${i?.count} 事件的 ${i?.group} 组`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`グループ ${i?.group} を ${i?.count} イベントで作成しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} इवेंट्स के साथ ${i?.group} ग्रुप बनाया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Criado o grupo ${i?.group} com eventos ${i?.count}`)
	return /** @type {LocalizedString} */ (`Created the group ${i?.group} with ${i?.count} events`)
});